module.exports = __webpack_public_path__ + "img/nubo-logo-purple.c2d86b85.svg";